import View from "../common/views/CarouselView";
import components from "./components.js";
components.define("js-Carousel", View);